/***
 *
 *   LOADER
 *   Infinite spinning animation for loading states
 *
 **********/

import React, { useState } from 'react';
import { ClassHelper } from 'components/lib';
import Style from './loader.tailwind.js';
import './loader.scss'

const coldEmailTips = [
  "Personalize the first line or don’t send it at all",
  "Sell the meeting, not the product",
  "Keep it skimmable—3 sentences beats 3 paragraphs",
  "Lead with their problem, not your solution",
  "One clear CTA is better than five options",
  "Sound human, not like a brochure",
  "Curiosity converts better than explanations",
  "If it can’t be read in 10 seconds, cut it",
  "Follow-ups close more deals than first emails",
  "Respect their time and they’ll give you some",
  "Use a subject line that clearly sets context and relevance",
  "Keep the email plain text — it reads like a real person",
  "Name a mutual connection or shared context to build instant credibility",
  "Drop one concrete metric or small outcome to prove you can deliver",
  "Close with a simple binary CTA: “15 min Tuesday or Thursday?”",
  "Add a short P.S. with one extra insight — people often read it",
  "Test subject lines and judge success by replies or meetings booked",
  "Cut the jargon — clear language beats cleverness every time",
  "Send from a real person and keep the signature minimal",
  "If you follow up, bring new value — never just nudge",
  "Start with relevance, not pleasantries",
  "Short emails feel easier to reply to — because they are",
  "Ask a question they can answer in one word",
  "Timing matters — send when your buyer is likely focused",
  "Replace “just checking in” with a fresh insight",
  "Specific beats impressive every time",
  "If your value isn’t clear by line two, rewrite it",
  "One email = one idea = one outcome",
  "Make replying feel like the smallest possible commitment",
  "End before they expect you to"
];

export function Loader(props) {
  const loaderStyle = ClassHelper(Style, props);
  const [tip, setTip] = useState(coldEmailTips[Math.floor(Math.random() * coldEmailTips.length)]);
  return (
    <>
      <div className={loaderStyle} style={{zIndex: 100}}>
        {/* <div id="circularG">
          <div id="circularG_1" className="circularG"></div>
          <div id="circularG_2" className="circularG"></div>
          <div id="circularG_3" className="circularG"></div>
          <div id="circularG_4" className="circularG"></div>
          <div id="circularG_5" className="circularG"></div>
          <div id="circularG_6" className="circularG"></div>
          <div id="circularG_7" className="circularG"></div>
          <div id="circularG_8" className="circularG"></div>
        </div> */}
        <div class="loader"></div>
      </div>
      <div
        className="absolute top-1/2 text-center w-full"
        style={{ marginTop: 60 }}
      >
        {props.children}
      </div>
      {!props.hideTip && <div
        className="absolute top-1/2 text-center w-full"
        style={{ 
          marginTop: props.children ? 
            ((window.location.pathname.includes("import-list") || window.location.pathname.includes("deliverability")) ? 120 : 90) : 
            60 
        }}
      >
        ...{tip}...
      </div>}
    </>
  );
}
